module.exports = __webpack_public_path__ + "files/01abffb868af28a7dd17e49eef8bfb23.png";